import React from 'react';
import { BentoGrid, BentoGridItem } from '../ui/bento-grid';
import ResultCard from './ResultCard';
import { SearchResult } from '../../contexts/SearchResultsContext';
import { getCardSize } from './cardSizes';

interface GridLayoutProps {
  items: SearchResult[];
  onTrack?: (resultId: string, type: string) => void;
  onClick?: (resultId: string) => void;
  singleRow?: boolean;
}

const GridLayout: React.FC<GridLayoutProps> = ({ items, onTrack, onClick, singleRow = false }) => {
  return (
    <BentoGrid className="max-w-7xl mx-auto" singleRow={singleRow}>
      {items.map((item, index) => {
        const cardSize = getCardSize(item.type);
        
        return (
          <BentoGridItem
            key={item.id}
            className={singleRow ? "" : cardSize.className}
            item={item}
            onTrack={(type) => onTrack?.(item.id, type)}
            singleRow={singleRow}
          />
        );
      })}
    </BentoGrid>
  );
};

export default GridLayout; 